<template>
    <section>
        <div v-if="!showPerformancePdf" class="container box mt-5">
            <h1 class="title">
                Detalle Compromisos de Desempeño del Académico
                <hr class="dropdown-divider" aria-role="menuitem">
            </h1>

            <div class="columns is-centered" v-if="academic_performances.state === 'ACEPTADA'">
              <div class="column is-10">
                <b-message has-icon type="is-success">
                  Este convenio de desempeño ya ha sido aceptado por el/la Director/a del departamento.
                </b-message>
              </div>
            </div>
            <div v-else>
              <div v-if="performanceInfo.is_active_phase_to_declare && !showAcademicInfo && academic_performances.state !== 'EMITIDA'" class="columns is-centered">
                <div class="column has-text-centered">
                  <b-button v-if="academic_performances.state === 'DEVUELTA'" label="Emitir Compromisos Rectificado" type="is-success" icon-left="check"
                            @click="showPerformancePdf = true" />
                  <b-button v-else label="Emitir Compromisos" type="is-success" icon-left="check"
                            @click="showPerformancePdf = true" />
                </div>
              </div>

              <div v-if="academic_performances.state === 'EMITIDA' && !isDirector" class="columns is-centered">
                <div class="column has-text-centered">
                  <b-button v-if="academic_performances.state === 'ACEPTADA'" label="ACEPTADA" type="is-success" icon-left="check"
                            disabled />
                  <b-button v-else label="EMITIDA" type="is-success" icon-left="check"
                            disabled />
                </div>
              </div>

              <div class="columns">
                <div class="column has-text-right">
                  <b-button v-if="performanceInfo.is_active_phase_to_declare && !showAcademicInfo && academic_performances.state !== 'EMITIDA'"
                            :label="`Editar Compromisos`" icon-left="edit" type="is-warning" tag="a"
                            href="/performances/declare" />
                </div>
              </div>

              <div v-if="academic_performances.state === 'DEVUELTA'" class="columns is-centered">
                <div class="column is-10 is-centered">
                  <b-message type="is-warning" has-icon title="Importante" aria-close-label="Close message">
                    Su convenio de desempeño fue devuelta por el Director de su departamento, con la siguiente observación: <b>{{academic_performances.comment}}</b>
                  </b-message>
                </div>
              </div>
            </div>


          <div v-if="academicInfo !== undefined && academicInfo != null && academicInfo.person !== undefined && academicInfo.person != null">
            <br>
            <div class="columns is-centered">
              <div class="column is-10 is-centered is-bordered-grey">

                <div class="columns">
                  <div class="column is-narrow">
                    <p>
                      <b>
                        Nombre:
                      </b>
                      {{ academicInfo.person.name + ' '
                    + academicInfo.person.last_name + ' '
                    + academicInfo.person.second_surname
                      }}
                    </p>
                  </div>

                  <div class="column">
                    <p>
                      <b>RUT:</b>
                      {{ academicInfo.person.rut }}
                    </p>
                  </div>

                </div>

                <div class="columns">
                  <div class="column is-narrow">
                    <p>
                      <b>Departamento: </b>
                      {{ academicInfo.unit_assigned + ` (CC ${academicInfo.unit_assigned_cost_center})` }}
                    </p>
                  </div>

                  <div class="column is-narrow">
                    <p>
                      <b>Jerarquía: </b>
                      {{ academicInfo.hierarchy_name }}
                    </p>
                  </div>

                  <div class="column">
                    <p>
                      <b>Jornada: </b>
                      {{ academicInfo.working_day_name ? academicInfo.working_day_name : 'No definida' }}
                    </p>
                  </div>

                </div>

              </div>
            </div>

            <br>
          </div>



            <div class="columns is-centered mb-6">
                <div class="column is-10 is-bordered-grey">
                    <AcademicConsolidated :academic_areas="academic_areas"
                        :performances="academic_performances.activity_performances" />
                </div>
            </div>

          <div class="columns is-centered" v-if="isRejecting">
            <div class="column is-10">
              <ValidationObserver v-slot="{ handleSubmit }">
                <form @submit.prevent="handleSubmit(onClickRejectPerformances)">
                  <b-field label="Ingrese motivo de devolución*">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <b-input v-model="rejectComment" type="textarea" placeholder="Ingrese motivo de la devolución de este compromiso de desempeño" />
                      <span class="validation-alert">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-field>

                  <div class="level-right buttons">
                    <b-button type="is-primary is-light" icon-left="arrow-left" @click="isRejecting = false">
                      Cancelar devolución
                    </b-button>
                    <b-button type="is-danger" icon-left="times" :disabled="!rejectComment" native-type="submit">
                      Devolver compromiso de desempeño
                    </b-button>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>

          <div class="columns" v-if="academic_performances.state === 'EMITIDA' && isDirector && !isRejecting">
            <div class="column has-text-right px-1">
              <b-button type="is-danger" icon-left="times" @click="isRejecting = true">
                Devolver compromisos
              </b-button>
            </div>
            <div class="column has-text-left px-1">
              <b-button type="is-success" icon-left="check" @click="onClickAcceptPerformances">
                Aceptar compromisos
              </b-button>
            </div>
          </div>

            <b-tabs position="is-centered">
                <b-tab-item label="Todos">
                    <div class="columns">
                        <div class="column has-text-right">
                            <b-button :label="isOpen ? 'Contraer Áreas' : 'Expandir Áreas'"
                                :icon-left="isOpen ? 'minus-circle' : 'plus-circle'" type="is-blue-color"
                                @click="isOpen = !isOpen" />
                        </div>
                    </div>
                    <AreaCommitmentsCollapse class="my-2" v-for="area in academic_areas" :academicArea="area" :isOpen="isOpen"
                        :performances="academic_performances.activity_performances.filter(x => x.alt_name_area === area.alt_name)" />
                </b-tab-item>
                <b-tab-item v-for="(academic_area, index) in academic_areas" :key="index"
                    :label="academic_area.alt_name">
                    <ShowTableCommitmentComponent :performances="academic_performances.activity_performances"
                        :academicArea="academic_area" />
                </b-tab-item>
            </b-tabs>

        </div>

        <div v-else class="container box mt-5">
            <DownloadAcademicPerformances :academicPerformances="academic_performances" :academicAreas="academic_areas"
                @close="showPerformancePdf = false" />
        </div>

        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
    </section>
</template>

<script>
import axios from 'axios'
import AcademicConsolidated from './AcademicConsolidated.vue';
import ShowTableCommitmentComponent from './ShowTableCommitmentComponent.vue';
import DownloadAcademicPerformances from './DownloadAcademicPerformances.vue';
import AreaCommitmentsCollapse from './AreaCommitmentsCollapse.vue';
import moment from 'moment'

export default {
    name: 'ShowPerformance',

    props: {
        year: {
            type: Number,
            required: true
        },
        personId: {
            type: Number,
            required: true
        },

        showAcademicInfo: {
            type: Boolean,
            required: true
        },
        isDirector: {
          type: Boolean,
          required: false,
          default: false,
        },
        personUserId:{
          type: Number,
          required: true
        }
    },

    components: {
        AcademicConsolidated,
        ShowTableCommitmentComponent,
        DownloadAcademicPerformances,
        AreaCommitmentsCollapse
    },

    data() {
        return {
            //Auxiliares
            isLoading: false,
            infoLoad: false,
            openedDetail: [],
            showPerformancePdf: false,
            isOpen: false,

            //Datos a traer
            academic_areas: [],
            academic_performances: {
                activity_performances: [],
            },
            performanceInfo: {},
            academicInfo: {},
            isRejecting: false,
            rejectComment: null,
        }
    },

    async created() {
        await this.getAcademicAreas()
        await this.getPerformances()
        await this.getPerformanceInfoForAcademic()
        await this.getAcademicInfo()
    },

    methods: {
        onClickRejectPerformances() {
          this.$buefy.dialog.confirm(
            {
              title: '¿Desea devolver este compromiso?',
              message: `Esta acción provocará que el/la académico/a <b>${this.academicInfo.person.name} ${this.academicInfo.person.last_name} ${this.academicInfo.person.second_surname}</b>
                        deba corregir su compromiso de desempeño según el motivo de devolución ingresado.<br>
                        Motivo de la devolución: <b>${this.rejectComment}</b>`,
              confirmText: 'Devolver',
              cancelText: 'Cancelar',
              type: 'is-danger',
              hasIcon: true,
              onConfirm: () => {
                this.postRejectPerformances()
              }
            }
          )
        },
      onClickAcceptPerformances() {
        this.$buefy.dialog.confirm(
          {
            title: '¿Desea aceptar este compromiso?',
            message: 'Esta acción requerirá que firmes el compromiso de desempeo, y una vez firmado, este quedará marcado como aceptado y no podrá ser modificado.',
            confirmText: 'Aceptar',
            cancelText: 'Cancelar',
            type: 'is-success',
            hasIcon: true,
            onConfirm: () => {
              this.postAcceptPerfromances();
            }
          }
        )
      },
      postAcceptPerfromances() {
        this.isLoading = true
        axios
          .post(`/performances/${this.academic_performances.id}/sign-principals.json`, {
            person_id: this.personUserId,
          })
          .then((response) => {
            this.goToSas(response.data)
          })
          .catch((error) => {
            this.$buefy.dialog.alert({
              title: "Error",
              message: "Hubo un error al aceptar el compromiso. Intente más tarde.",
              type: "is-danger",
              hasIcon: true,
              confirmText: "Ok",
            })
          })
          .finally(() => {
            this.isLoading = false;
          })
      },
      postRejectPerformances() {
        this.isLoading = true
        axios
          .post("/performances/stop-process-performance.json", {
            id: this.academic_performances.id,
            comment: this.rejectComment,
          })
          .then(() => {
            this.$buefy.dialog.alert({
              title: "¡Éxito!",
              message: "El compromiso de desempeño ha sido devuelto exitosamente.",
              type: "is-success",
              hasIcon: true,
              confirmText: "Ok",
              onConfirm: () => {
                location.reload();
              },
            })
          })
          .catch((error) => {
            this.$buefy.dialog.alert({
              title: "Error",
              message: "Hubo un error al devolver el compromiso. Intente más tarde.",
              type: "is-danger",
              hasIcon: true,
              confirmText: "Ok",
            })
          })
          .finally(() => {
            this.isLoading = false;
          })
      },
      async goToSas(data) {
        window.location.href = `${data.url}?email=${data.email}`
      },


        async getAcademicAreas() {
            this.isLoading = true
            await axios
                .get('/academic_areas.json')
                .then(response => {
                    this.academic_areas = response.data
                    this.academic_activities_teaching = this.academic_areas[0].academic_activities
                    this.academic_activities_develop = this.academic_areas[1].academic_activities
                    this.academic_activities_technical_assistance = this.academic_areas[2].academic_activities
                    this.academic_activities_improvement = this.academic_areas[3].academic_activities
                    this.academic_activities_academic_administration = this.academic_areas[4].academic_activities
                    this.academic_activities_extension = this.academic_areas[5].academic_activities
                    this.academic_activities_continuing_education = this.academic_areas[6].academic_activities
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        iconPack: 'fa',
                        icon: 'times-circle',
                        confirmText: 'Ok',
                    })
                })
                .finally(() => {
                    this.isLoading = false
                })
        },

        async getPerformances() {
            this.isLoading = true
            await axios
                .get(`/performances/process/${this.year}/person/${this.personId}.json`)
                .then(response => {
                    this.academic_performances = response.data

                    let index = 1
                    this.academic_performances.activity_performances.forEach((performance) => {
                        performance.commitment_index = index
                        index++
                    })
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        iconPack: 'fa',
                        icon: 'times-circle',
                        confirmText: 'Ok',
                    })
                })
                .finally(() => {
                    this.isLoading = false
                })
        },

        async getPerformanceInfoForAcademic() {
            this.isLoading = true
            await axios
                .get('/performances/get-performance-info-for-academic.json', {
                    params: {
                        person_id: this.personId
                    }
                })
                .then(async response => {
                    this.performanceInfo = response.data
                    this.performanceInfo.phase.start_date = moment(this.performanceInfo.phase.start_date, ["YYYY-MM-DD", "DD-MM-YYYY"])
                    this.performanceInfo.phase.end_date = moment(this.performanceInfo.phase.end_date, ["YYYY-MM-DD", "DD-MM-YYYY"])
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        iconPack: 'fa',
                        icon: 'times-circle',
                        confirmText: 'Ok',
                    })
                })
                .finally(() => {
                    this.isLoading = false
                })
        },

        async getAcademicInfo() {
            this.isLoading = true
            await axios
                .get(`/people/${this.personId}/my-all-academic-data.json`)
                .then(response => {
                    this.academicInfo = response.data
                    this.infoLoad = true
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        iconPack: 'fa',
                        icon: 'times-circle',
                        confirmText: 'Ok',
                    })
                }).finally(() => {
                    this.isLoading = false
                })
        }
    }
}
</script>